import React from "react";
import "./EditCustomerDetails.css";
import { withRouter } from "react-router-dom";
import withSnackbar from "../../util/withSnackbar";
import { SNACKBAR_OPTIONS, TIMEOUT, FLUX_WEBHOOK_URL } from "../../constants/CommonConstants";
import { injectIntl } from "react-intl";
import Header from "../CeHeader/Header";
import { LinearProgress } from "@mui/material";
import Button from "@mui/material/Button";
import _ from "lodash";
import cognitoAuth from "../../util/Cognito";
import ConfirmationDialog from "../Common/ConfirmationDialog";
import { errorHandle } from "../../Common/errorHandle";
import { timezoneInfoObj } from "../Common/timezoneData";
import { isKM1Machine, encrypt, toBase64Url } from "../../util/util";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import { LOG_STATUS_VALUE } from "../../constants/LogEventConstants";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import TransportLogDialog from "./component/TransportLogDialog";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Switch } from "@mui/material";
const defaultTimezoneUiId = "TZ_0000";

const LicenseFeature = {
  Ultimate: "Ultimate SI",
  JobManager: "JobManager",
  JobManagerSchedule: "JobManagerSchedule",
};

// config serial number length (must be 0 or 13)
const serialNumberLengthLimit = {
  min: 0,
  max: 13,
};
class editCustomerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ceId: this.props.location.state.ceId,
      userId: this.props.location.state.userId,
      timeZoneList: Object.keys(timezoneInfoObj),
      user: {
        userId: "",
        tenantId: "",
        mailAddress: "",
        licenseList: [],
        machineList: [],
        ceList: [],
        ultimateUpdatedAt: "",
        feature: "",
        showAqaQuality: false,
        isLocation:false,
        isFlux:false
      },
      ultimateChecked: false,
      jobManagerChecked: false,
      jobManagerScheduleChecked: false,
      ultimateDisabled: true,
      jobManagerDisabled: true,
      JobManagerScheduleDisabled: true,
      userBeforeChange: {},
      successDisplay: "none",
      isProgress: false,
      showConfirmationDialog: false,
      error: "",
      serialNumberVaild: true,
      showTransportLogDialogFlag: false,
      transportLogMachines:[],
      isChangeEmail:false,
    };
  }
  
  componentDidMount() {
    let header = {
      Authorization: "",
    };

    this.setState({ isProgress: true });
    cognitoAuth
      .getAuthorizationToken()
      .then(
        (token) => {
          header.Authorization = token;
        },
        (error) => {
          this.setState({ isProgress: false });
          throw error;
        }
      )
      .then(() => {
        const controller = new AbortController();
        const props = this;
        const timer = window.setTimeout(
          errorHandle(function () {
            controller.abort();
            throw props;
          }),
          TIMEOUT
        );
        let userQs = new URLSearchParams({
          userId: this.state.userId,
        });
        let getUser = fetch(process.env.REACT_APP_CE_USER + `?${userQs}`, {
          method: "GET",
          headers: header,
          signal: controller.signal,
        });

        Promise.all([getUser])
          .then((responses) => {
            window.clearTimeout(timer);
            let response = responses[0];
            if (!response.ok) {
              if (response.status === 408) {
                // エラーメッセージ表示
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "http_connection_error",
                  })
                );
              } else {
                // エラーメッセージ表示
                this.props.openSnackbar(
                  this.props.intl.formatMessage(
                    { id: "http_get_error" },
                    { status: response.status }
                  )
                );
                // ログイン画面に遷移させる
                this.props.history.push({ pathname: "/" });
              }
            }
            return response.json();
          })
          .then((res) => {
            // if the machine not have timezoneInfo then add default timezone Info
            if (res.machineList.length) {
              res.machineList.map((value, index) =>
                value.timeZoneInfo
                  ? ""
                  : (value.timeZoneInfo = {
                      uiId: defaultTimezoneUiId,
                      tzId: timezoneInfoObj[defaultTimezoneUiId],
                    })
              );
            }
            this.state.transportLogMachines=_.cloneDeep(res.machineList)
            this.state.user = { ...this.state.user, ...res };
            this.state.userBeforeChange = _.cloneDeep({...this.state.user, ...res});
            return res;
          })
          .then((res) => {
            Promise.all(
              res.machineList.map((machine) => {
                // 各マシンの利用可否を取得する
                let machineQs = new URLSearchParams({
                  userId: res.userId,
                  serialNumber: machine.serialNumber,
                });
                return fetch(
                  process.env.REACT_APP_CE_USER_MACHINE_AVAILABILITY +
                    `?${machineQs}`,
                  {
                    method: "GET",
                    headers: header,
                    signal: controller.signal,
                    referrer: "about:client",
                    referrerPolicy: "no-referrer-when-downgrade",
                  }
                );
              })
            ).then((responses) => {
              Promise.all(responses.map((res) => res.json()))
                .then((results) => {
                  let machineList = this.state.user.machineList;
                  results.forEach((result, index) => {
                    if (result.isAvailable) {
                      machineList[index].latestDate = result.latestDate;
                      machineList[index].sendLogDate = result.sendLogDate;
                    }
                  });
                  let user = this.state.user;
                  user.machineList = machineList;
                  this.setState({
                    user: user,
                    userBeforeChange: _.cloneDeep(user),
                    ultimateChecked: user.licenseList.some(
                      (lc) => lc.feature === LicenseFeature.Ultimate
                    ),
                    jobManagerChecked: user.licenseList.some(
                      (lc) => lc.feature === LicenseFeature.JobManager
                    ),
                    jobManagerScheduleChecked: user.licenseList.some(
                      (lc) => lc.feature === LicenseFeature.JobManagerSchedule
                    ),
                    ultimateDisabled: user.licenseList.some(
                      (lc) => lc.feature === LicenseFeature.Ultimate
                    ),
                    jobManagerDisabled: user.licenseList.some(
                      (lc) => lc.feature === LicenseFeature.JobManager
                    ),
                    JobManagerScheduleDisabled: user.licenseList.some(
                      (lc) => lc.feature === LicenseFeature.JobManagerSchedule
                    ),
                    
                  });
                })
                .finally(() => {
                  this.setState({ isProgress: false });
                });
            });
          });
      })
      .catch(() => {
        cognitoAuth.sessionTimeOut(this.props);
        this.setState({ isProgress: false });
      });
  }
  onClickAddSerialNumber() {
    let user = this.state.user;
      user.machineList.push({
        serialNumber: "",
        name: "",
        latestDate: "",
        timeZoneInfo: {
          uiId: defaultTimezoneUiId,
          tzId: timezoneInfoObj[defaultTimezoneUiId],
        },
        logStatus: "",
        sendLogDate: "",
      });
      this.setState({
        user: user,
      });
  }
  onClickTransportLog() {
    this.setState({
      showTransportLogDialogFlag: true,
    });
  }
  onChangeSerialNumber(index, sn) {
    let user = this.state.user;
    sn = sn.toUpperCase();
    user.machineList[index].serialNumber = sn;
    let flag = isKM1Machine(sn) && sn.length >= 13;
    if (flag) {
      let header = {
        Authorization: "",
      };
      if (!!sn) {
        this.setState({ isProgress: true });
        cognitoAuth
          .getAuthorizationToken()
          .then(
            (token) => {
              header.Authorization = token;
            },
            (error) => {
              this.setState({ isProgress: false });
              throw error;
            }
          )
          .then(() => {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(
              errorHandle(function () {
                controller.abort();
                throw props;
              }),
              TIMEOUT
            );
            let userQs = new URLSearchParams({
              serialNumber: sn,
            });
            fetch(process.env.REACT_APP_CE_TIMEZONE + `?${userQs}`, {
              method: "GET",
              headers: header,
              signal: controller.signal,
            })
              .then((response) => {
                window.clearTimeout(timer);
                if (!response.ok) {
                  if (response.status === 408) {
                    // エラーメッセージ表示
                    this.props.openSnackbar(
                      this.props.intl.formatMessage({
                        id: "http_connection_error",
                      })
                    );
                  } else {
                    // エラーメッセージ表示
                    this.props.openSnackbar(
                      this.props.intl.formatMessage(
                        { id: "http_get_error" },
                        { status: response.status }
                      )
                    );
                    // ログイン画面に遷移させる
                    this.props.history.push({
                      pathname: "/ce",
                    });
                  }
                }
                return response.json();
              })
              .then((res) => {
                if (res.isExist) {
                  document.getElementById("time-zone-select" + index).value =
                    res.timeZoneInfo.uiId;
                  user.machineList[index].timeZoneInfo = res.timeZoneInfo;
                  document.getElementById("send_log_date" + index).value =
                    res.sendLogDate;
                  user.machineList[index].sendLogDate = res.sendLogDate;
                } else {
                  document.getElementById("time-zone-select" + index).value =
                    "TZ_0000";
                  user.machineList[index].timeZoneInfo = {
                    uiId: "TZ_0000",
                    tzId: timezoneInfoObj["TZ_0000"],
                  };
                }
              });
            this.setState({ isProgress: false });
          });
      }
    }

    this.setState(
      () => ({ user: user }),
      () => this.validateSerialNumberLength() // Checking for Serial Number Length
    );
  }
  onClickDeleteSerialNumber(index) {
    let user = this.state.user;
    user.machineList.splice(index, 1);
    this.setState(
      () => ({ user: user }),
      () => this.validateSerialNumberLength() // Checking for Serial Number Length
    );
  }
  onClickDeleteAllSerialNumber() {
    let user = this.state.user;
    let length = user.machineList.length;
    user.machineList.splice(0, length);
    this.setState({
      user: user,
    });
  }
  onClickAddCe() {
    let user = this.state.user;
    user.ceList.push({
      ceId: "",
      authorizer: "",
    });
    this.setState({
      user: user,
    });
  }
  onChangeCe(index, value, kind) {
    let user = this.state.user;
    if (kind === "ceId") {
      user.ceList[index].ceId = value;
    } else {
      user.ceList[index].authorizer = value;
    }
    this.setState({
      user: user,
    });
  }
  onClickDeleteCe(index) {
    let user = this.state.user;
    user.ceList.splice(index, 1);
    this.setState({
      user: user,
    });
  }
  goSuggestion() {
    this.props.history.push({
      pathname: `/ce/top/editCustomer/editSuggestion`,
      search: `?userId=${this.state.userId}`,
    });
  }
  onSerialNumberValidation(event) {
    let regexp = /^[A-Za-z0-9]+$/;
    if (!regexp.test(event.target.value)) {
      event.target.value = "";
      return;
    }
  }
  // Create for checking Serial Number Length
  validateSerialNumberLength() {
    const { min, max } = serialNumberLengthLimit;
    const validItems = this.state.user.machineList.filter(
      (item) =>
        item.serialNumber.length === min || item.serialNumber.length === max
    );
    if (validItems.length !== this.state.user.machineList.length) {
      if (this.state.serialNumberVaild) {
        this.setState({
          serialNumberVaild: false,
        });
      }
    } else {
      if (!this.state.serialNumberVaild) {
        this.setState({
          serialNumberVaild: true,
        });
      }
    }
  }
  registerBtnClassName() {
    return _.isEqual(this.state.user, this.state.userBeforeChange) ||
      this.state.isProgress ||
      !this.state.serialNumberVaild
      ? "disabled"
      : "button";
  }
  handleUltimateChanged = (e) =>
    this.setState({ ultimateChecked: e.target.checked }, () => {
      const { ultimateChecked, ultimateDisabled, user } = this.state;
      if (ultimateChecked && !ultimateDisabled) {
        this.setState({
          user: { ...user, feature: LicenseFeature.Ultimate },
        });
      }
      if (!ultimateChecked) {
        this.setState({ user: { ...user, feature: "" } });
        this.onClickDeleteAllSerialNumber();
      }
    });
  handleJobManagerChanged = (e) =>
    this.setState({ jobManagerChecked: e.target.checked }, () => {
      const { jobManagerChecked, jobManagerDisabled, user } = this.state;
      if (jobManagerChecked && !jobManagerDisabled) {
        this.setState({
          user: { ...user, feature: LicenseFeature.JobManager },
        });
      }
      if (!jobManagerChecked) {
        this.setState({ user: { ...user, feature: "", isLocation: false } });
      }
    });
  async updateUltimateUser() {
    this.setState({
      error: "",
    });
    let header = {
      Authorization: "",
      "Content-Type": "application/json",
    };

    this.setState({ isProgress: true });
    cognitoAuth
      .getAuthorizationToken()
      .then(
        (token) => {
          header.Authorization = token;
        },
        (error) => {
          this.setState({ isProgress: false });
          throw error;
        }
      )
      .then(() => {
        const controller = new AbortController();
        const props = this;
        const timer = window.setTimeout(
          errorHandle(function () {
            controller.abort();
            throw props;
          }),
          TIMEOUT
        );
        let machineList = this.state.user.machineList.filter(
          (item) => !_.isEmpty(item.serialNumber)
        );
        for (let key in machineList) {
          this.state.user.machineList[key].serialNumber =
            machineList[key].serialNumber.toUpperCase();
        }
        let paramsObj = {
          userId: this.state.user.userId,
          machineList: machineList,
          ceList: this.state.user.ceList,
          updatedAt: this.state.user.ultimateUpdatedAt,
          showAqaQuality: this.state.user.showAqaQuality,
        }
        if(this.state.isChangeEmail){
          paramsObj.mailAddress = this.state.user.mailAddress;
        }
        fetch(process.env.REACT_APP_CE_USER, {
          method: "PUT",
          headers: header,
          signal: controller.signal,
          body: JSON.stringify(paramsObj),
        })
          .then((res) => {
            window.clearTimeout(timer);
            this.setState({ isProgress: false });
            if (res.ok) {
              if (this.props.history.location.pathname === "/ce/top/editCustomer") {
                this.jumpToListPage();
              }
            } else {
              return res.json();
            }
          })
          .then((error) => {
            if (error) {
              if (error.status === 400) {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "ce_error_400",
                  })
                );
              } else if (error.status === 409) {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "ce_error_409",
                  })
                );
                document.location.reload();
              } else {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "server_error",
                  })
                );
              }
            }
          })
          .finally(() => {
            this.setState({ isProgress: false });
          });
      })
      .catch(() => {
        cognitoAuth.sessionTimeOut(this.props);
        this.setState({ isProgress: false });
      });
  }
  updateTimezone(value, index) {
    let user = this.state.user;
    user.machineList[index].timeZoneInfo.uiId = value;
    user.machineList[index].timeZoneInfo.tzId = timezoneInfoObj[value]
      ? timezoneInfoObj[value]
      : timezoneInfoObj[defaultTimezoneUiId];
    this.setState({
      user: user,
    });
  }
  registerUser = () => {
    const { mailAddress, machineList, authorizer, userId, tenantId, feature, isLocation } =
      this.state.user;
    let header = {
      Authorization: "",
      "Content-Type": "application/json",
    };
    let body = {
      machineList: machineList.map((machine) => machine.serialNumber),
      mailAddress,
      authorizer,
      userId,
      tenantId,
      feature,
      isNewService: !!feature,
      isLocation
    };

    if (!body.machineList.every((v, i, self) => self.indexOf(v) === i)) {
      this.setState({ showConfirmationDialog: false });
      this.props.openSnackbar(
        this.props.intl.formatMessage({ id: "serial_number_duplicate_error" })
      );
      return;
    }
    this.setState({ isProgress: true });
    cognitoAuth
      .getAuthorizationToken()
      .then(
        (token) => {
          header.Authorization = token;
        },
        (error) => {
          this.setState({ isProgress: false });
          throw error;
        }
      )
      .then(() => {
        const controller = new AbortController();
        const props = this;
        const timer = window.setTimeout(
          errorHandle(function () {
            controller.abort();
            throw props;
          }),
          TIMEOUT
        );
        fetch(process.env.REACT_APP_CE_USER, {
          method: "POST",
          headers: header,
          signal: controller.signal,
          body: JSON.stringify(body),
        })
          .then((res) => {
            window.clearTimeout(timer);
            this.setState({ isProgress: false });
            if (res.ok) {
              this.jumpToListPage();
            } else {
              return res.json();
            }
          })
          .then((error) => {
            if (error) {
              if (error.status === 400) {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "ce_error_400",
                  })
                );
              } else if (error.status === 409) {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "ce_error_409",
                  })
                );
                document.location.reload();
              } else {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "server_error",
                  })
                );
              }
            }
          })
          .finally(() => {
            this.setState({ isProgress: false });
          });
      })
      .catch(() => {
        cognitoAuth.sessionTimeOut(this.props);
        this.setState({ isProgress: false });
      });
  };
  async updateJMUser() {
    this.setState({
      error: "",
    });
    let header = {
      Authorization: "",
      "Content-Type": "application/json",
    };
    let paramsObj = {
      userId: this.state.user.userId,
      isLocation:this.state.user.isLocation,
    }
    if(this.state.isChangeEmail){
      paramsObj.mailAddress = this.state.user.mailAddress;
    }

    this.setState({ isProgress: true });
    cognitoAuth
      .getAuthorizationToken()
      .then(
        (token) => {
          header.Authorization = token;
        },
        (error) => {
          this.setState({ isProgress: false });
          throw error;
        }
      )
      .then(() => {
        const controller = new AbortController();
        const props = this;
        const timer = window.setTimeout(
          errorHandle(function () {
            controller.abort();
            throw props;
          }),
          TIMEOUT
        );
        fetch(process.env.REACT_APP_CE_JMUSER, {
          method: "PUT",
          headers: header,
          signal: controller.signal,
          body: JSON.stringify(paramsObj),
        })
          .then((res) => {
            window.clearTimeout(timer);
            this.setState({ isProgress: false });
            if (res.ok) {
              if (this.props.history.location.pathname === "/ce/top/editCustomer") {
                this.jumpToListPage();
              }
            } else {
              return res.json();
            }
          })
          .then((error) => {
            if (error) {
              if (error.status === 400) {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "ce_error_400",
                  })
                );
              } else if (error.status === 409) {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "ce_error_409",
                  })
                );
                document.location.reload();
              } else {
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "server_error",
                  })
                );
              }
            }
          })
          .finally(() => {
            this.setState({ isProgress: false });
          });
      })
      .catch(() => {
        cognitoAuth.sessionTimeOut(this.props);
        this.setState({ isProgress: false });
      });
  }
  handleUpdate = () => {
    let machineList = this.state.user.machineList.filter(
      (item) => !_.isEmpty(item.serialNumber)
    );
    const uppercaseSerialNumbers = machineList.map((obj) =>
      obj.serialNumber.toUpperCase()
    );
    if (!uppercaseSerialNumbers.every((v, i, self) => self.indexOf(v) === i)) {
      this.setState({
        error: this.props.intl.formatMessage({
          id: "serial_number_duplicate_error",
        }),
      });

      return;
    }
    this.setState({
      showConfirmationDialog: true,
    });
  };
  handleRegister = () => {
    const { user, ultimateDisabled } = this.state;
    let error = this.validateInput();
    this.setState({
        error: error,
        showConfirmationDialog: false,
    });
    if (error !== ''){
      return;
    }

    const isUltimateInfoChanged = this.checkUpdateParams();
    if (ultimateDisabled && (this.state.isChangeEmail || isUltimateInfoChanged)) {
      this.updateUltimateUser();
    }
    if (!!user.feature) {
      this.registerUser();
    }

    if(this.state.user.isLocation !== this.state.userBeforeChange.isLocation || this.state.isChangeEmail){
      this.updateJMUser();
    }
  };
  // check ce user info is updated
  checkUpdateParams = () => {
    const isUltimateInfoChanged = this.state.user.showAqaQuality !== this.state.userBeforeChange.showAqaQuality 
                            || this.arraysEqualIgnoreOrder(this.state.user.machineList, this.state.userBeforeChange.machineList)
                            || this.state.user.ceList.length !== this.state.userBeforeChange.ceList.length;
    return isUltimateInfoChanged;
  }
  arraysEqualIgnoreOrder = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return true;
    
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();
    
    for (let i = 0; i < sortedArr1.length; i++) {
      if (JSON.stringify(sortedArr1[i]) !== JSON.stringify(sortedArr2[i])) {
        return true;
      }
    }
    
    return false;
  }
  updateTransportLog = (machineInfoList) => {
    this.setState({
      showTransportLogDialogFlag:false
    })
    let machineList = machineInfoList.map((item) => {
      return {
        serialNumber: item.sn,
        transferLogInfo: [
          { env: "dev", transferFlag: item.dev },
          { env: "sam", transferFlag: item.sam },
        ],
      };
    });
    let header = {
      Authorization: "",
      "Content-Type": "application/json",
    };
    this.setState({ isProgress: true, });
    cognitoAuth
      .getAuthorizationToken()
      .then(
        (token) => {
          header.Authorization = token;
        },
        () => {
          this.setState({ isProgress: false });
          cognitoAuth.sessionTimeOut(this.props);
        }
      )
      .then(() => {
        const controller = new AbortController();
        const props = this;
        const timer = window.setTimeout(
          errorHandle(function () {
            controller.abort();
            throw props;
          }),
          TIMEOUT
        );
        fetch(process.env.REACT_APP_CE_TRANSPORT_LOG , {
            method: "PUT",
            headers: header,
            signal: controller.signal,
            body: JSON.stringify({machineList:machineList}),
        })
          .then((response) => {
            window.clearTimeout(timer);
            this.setState({ isProgress: false });
            if (!response.ok) {
              if (response.status === 408) {
                // エラーメッセージ表示
                this.props.openSnackbar(
                  this.props.intl.formatMessage({ id: "http_connection_error" })
                );
                return;
              } else {
                // エラーメッセージ表示
                this.props.openSnackbar(
                  this.props.intl.formatMessage(
                    { id: "http_get_error" },
                    { status: response.status }
                  )
                );
                // ログイン画面に遷移させる
                this.props.history.push({ pathname: "/" });
                return;
              }
            }
            return response.json();
          })
          .then((data) => { 
            let machines=_.clone(this.state.transportLogMachines)
            let updateMachines=machines.map((item) => {
              let i=machineList.findIndex(it=>it.serialNumber === item.serialNumber)
              if(i !==-1){
                item.transferLogInfo=machineList[i].transferLogInfo
                return item
              }
            })
            this.state.transportLogMachines=updateMachines

          });
      });

  };
  jumpToListPage = () => {
    const pathname = `/ce/top`;
    const state = { ceId: cognitoAuth.getUserName() };
    const history = { pathname, state };
    this.props.history.push(history);
  };
  downloadJsonFile = (filename) => {
    let header = {
      Authorization: "",
      "Content-Type": "application/json",
    };
    this.setState({ isProgress: true });
    cognitoAuth
      .getAuthorizationToken()
      .then(
        (token) => {
          header.Authorization = token;
        },
        (error) => {
          this.setState({ isProgress: false });
          throw error;
        }
      )
      .then(() => {
        const controller = new AbortController();
        const props = this;
        const timer = window.setTimeout(
          errorHandle(function () {
            controller.abort();
            throw props;
          }),
          TIMEOUT
        );

        let userQs = new URLSearchParams({
          userId: this.state.userId,
        });
        let getJmUser = fetch(
          process.env.REACT_APP_CE_GET_JM_USER_INFO + `?${userQs}`,
          {
            method: "GET",
            headers: header,
            signal: controller.signal,
          }
        );

        Promise.all([getJmUser])
          .then((responses) => {
            window.clearTimeout(timer);
            let response = responses[0];
            if (!response.ok) {
              if (response.status === 408) {
                // エラーメッセージ表示
                this.props.openSnackbar(
                  this.props.intl.formatMessage({
                    id: "http_connection_error",
                  })
                );
              } else {
                // エラーメッセージ表示
                this.props.openSnackbar(
                  this.props.intl.formatMessage(
                    { id: "http_get_error" },
                    { status: response.status }
                  )
                );
                // ログイン画面に遷移させる
                this.props.history.push({ pathname: "/" });
              }
            }
            return response.json();
          })
          .then((res) => {
            let data = {
              url: res.url,
              usr: res.usr,
              ope: res.ope,
              pwd: res.pwd,
            };
            const json = JSON.stringify(data, null, "  ");
            const blob = new Blob([json], { type: "application/json" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            link.click();

            URL.revokeObjectURL(url);
          })
          .finally(() => {
            this.setState({ isProgress: false });
          });
      })
      .catch(() => {
        cognitoAuth.sessionTimeOut(this.props);
        this.setState({ isProgress: false });
      });
  };
  MashineListLayout = (machineList) => {
    return (
      <div className="machineList infoList">
        <div className="listHeader ml-row">
          <div className="ml-cell">
            {this.props.intl.formatMessage({
              id: "ce_edit_registered",
            })}
          </div>
          <div className="ml-cell">
            <span>
              {this.props.intl.formatMessage({
                id: "ce_edit_serialNumber",
              })}
            </span>
          </div>
          <div className="ml-cell">
            <span>
              {this.props.intl.formatMessage({
                id: "time_zone_title",
              })}
            </span>
          </div>
          <div className="ml-cell">
            <span>
              {this.props.intl.formatMessage({
                id: "ce_edit_lastUpdatedDate",
              })}
            </span>
          </div>
          <div className="ml-cell"></div>
        </div>
        <div className="listContent">
          {machineList.map((machine, index) => (
            <div key={index} className="ml-row">
              <div
                className="ml-cell"
                title={
                  machine.logStatus
                    ? machine.logStatus === "normal"
                      ? ""
                      : this.props.intl.formatMessage({
                          id: getMachineLogStatus(machine.logStatus),
                        })
                    : ""
                }
              >
                {this.machineStatus(machine)}
              </div>
              <div className="ml-cell">
                <input
                  id="serialNumberInput"
                  type="text"
                  className={
                    machine.serialNumber.length !==
                      serialNumberLengthLimit.min &&
                    machine.serialNumber.length !== serialNumberLengthLimit.max
                      ? "serialNumberStyle withLengthError"
                      : "serialNumberStyle"
                  }
                  name="serialNumber"
                  value={machine.serialNumber}
                  onInput={(event) => {
                    this.onSerialNumberValidation(event);
                  }}
                  onChange={(event) => {
                    this.onChangeSerialNumber(index, event.target.value);
                  }}
                />
              </div>
              <div className="ml-cell">
                <select
                  className="time-zone-select"
                  id={"time-zone-select" + index}
                  defaultValue={
                    machine.timeZoneInfo && machine.timeZoneInfo.uiId
                      ? machine.timeZoneInfo.uiId
                      : defaultTimezoneUiId
                  }
                  disabled={!isKM1Machine(machine.serialNumber)}
                  onChange={(e) => this.updateTimezone(e.target.value, index)}
                >
                  {this.state.timeZoneList.map((value, index) => (
                    <option key={index} value={value}>
                      {isKM1Machine(machine.serialNumber)
                        ? this.props.intl.formatMessage({ id: value })
                        : this.props.intl.formatMessage({ id: "local_time" })}
                    </option>
                  ))}
                </select>
              </div>
              <div className="ml-cell">
                <input
                  id={"send_log_date" + index}
                  type="text"
                  name="sendLogDate"
                  value={machine.sendLogDate}
                  disabled
                />
              </div>
              <div className="ml-cell">
                <img
                  className="delete-icon"
                  src="/assets/img/icon_recycle_bin_24.svg"
                  alt="icon_delete"
                  onClick={() => this.onClickDeleteSerialNumber(index)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  CEListLayout = (ceList) => {
    return (
      <div className="ceList infoList">
        <div className="listHeader ml-row">
          <div className="ml-cell">
            {this.props.intl.formatMessage({
              id: "ce_edit_responsibleCE",
            })}
          </div>
          <div className="ml-cell">
            <span>
              {this.props.intl.formatMessage({
                id: "authorizer",
              })}
            </span>
          </div>
          <div className="ml-cell"></div>
        </div>
        <div className="listContent">
          {ceList.map((ce, index) => (
            <div key={index} className="ml-row">
              <div className="ml-cell">
                <span>{ce.ceId}</span>
              </div>
              <div className="ml-cell">
                <span>{ce.authorizer}</span>
              </div>
              <div className="ml-cell">
                {ceList.length > 1 ? (
                  <img
                    className="delete-icon"
                    src="/assets/img/icon_recycle_bin_24.svg"
                    alt="icon_delete"
                    onClick={() => this.onClickDeleteCe(index)}
                  />
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  handleShowAqaQuality = (e) => {
    let user = this.state.user;
    user.showAqaQuality = e;
    this.setState({
      user: user,
    });
  };
  handleLocationOnOff = (e) => {
    let user = this.state.user;
    user.isLocation = e;
    this.setState({
      user: user,
    });
  };
  machineStatus(machine) {
    let icon = "";
    switch (machine.logStatus) {
        case LOG_STATUS_VALUE.NORMAL:
            icon = <CheckCircleOutlineOutlinedIcon sx={{ fontSize: 30 }}/>
            break;
        case LOG_STATUS_VALUE.NO_LOG:
        case LOG_STATUS_VALUE.UNUSED_LOG: 
            icon = <ErrorOutlineOutlinedIcon sx={{ color: "#d83737",fontSize: 30 }}/>;
            break;
        default:
            break;
    }
    return icon;
  }
  handleChangeEmail(currentValue){
    let userObj = this.state.user;
    userObj.mailAddress = this.state.userBeforeChange.mailAddress;
    this.setState({
      isChangeEmail : !currentValue,
      user:userObj
    })
  }
 onEmailValidation(event) {
    let regexp = /^[A-Za-z0-9_.\-@]+$/;
    let str = event.target.value;
    if (!regexp.test(str)) {
        str = str.split('').filter((char) => regexp.test(char) === true).join('')
        event.target.value = str;
    }
  }
  onEmailChange(value) {
    let user = this.state.user;
    user.mailAddress = value;
    this.setState({
      user: user
    })
  }
  validateInput() {
    let error = '';

    if (!this.state.user.mailAddress) {
        error = error.concat(this.props.intl.formatMessage({ id: "fields_compulsory" }))
        return error;
    } else {
        let emailValidation = /\S+@\S+\.\S+/;
        let isEMailValid = emailValidation.test(this.state.user.mailAddress);

        if (!isEMailValid ) {
            error = error.concat(this.props.intl.formatMessage({ id: "email_error" }));
        }
    }
    return error;
  }
  async copywebhookInfoToClipboard(){
    const encryptedCompanyId = toBase64Url(encrypt(this.state.userId));
    const copyInfo = FLUX_WEBHOOK_URL[process.env.REACT_APP_BUILD_ENV]+ "?companyId="+encryptedCompanyId;
    await navigator.clipboard.writeText(copyInfo);
  };
  render() {
    let licenseList=_.cloneDeep(this.state.user.licenseList)

    let ultimateLicense = licenseList?.find(
      (lc) => lc.feature === LicenseFeature.Ultimate
    );

    let jobManagerLicense = licenseList?.find(
      (lc) => lc.feature === LicenseFeature.JobManager
    );

    let JobManagerScheduleLicense = licenseList?.find(
      (lc) => lc.feature === LicenseFeature.JobManagerSchedule
    );

    if (ultimateLicense && moment(ultimateLicense?.endDate) < moment()) {
      ultimateLicense.endDate = "";
    }

    if (jobManagerLicense && moment(jobManagerLicense?.endDate) < moment()) {
      jobManagerLicense.endDate = "";
    }

    if (JobManagerScheduleLicense && moment(JobManagerScheduleLicense?.endDate) < moment()) {
      JobManagerScheduleLicense.endDate = "";
    }

    return (
      <div id="ceEditCustomerDetails" className="body">
        {this.state.isProgress ? <LinearProgress /> : ""}
        <Header showSubMenu={true} customerUserId={this.state.user.userId} />
        <div className="ceEdit-content">
          <div className="ceEdit-title">
            {this.props.intl.formatMessage({id: "edit_customer_title"})}
          </div>
          {/* 顧客情報 */}
          <div className="customerInfo">
            <div className="customerInfo-titleContainer">
              <div className="customerInfo-title">
                {this.props.intl.formatMessage({id: "ce_edit_customerInfo"})}
              </div>
              <div className="editMail-switch">
                <div style={{fontSize:"14px",marginRight:"5px"}}>{this.props.intl.formatMessage({id:"ce_edit_email_button"})}</div>
                <Switch 
                  checked={this.state.isChangeEmail}
                  onChange={() => this.handleChangeEmail(this.state.isChangeEmail)}
                  sx={{
                    width: "28px",
                    height: "14px",
                    padding: 0,
                    display: "flex",
                    "&:active": {
                      "& .MuiSwitch-thumb": {
                        width: "10px",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        transform: "translateX(9px)",
                      },
                    },
                    "& .MuiSwitch-switchBase": {
                      padding: "2px 3px",
                      position: "absolute",
                      color: "#fff",
                      cursor: "pointer",
                      "&.Mui-checked": {
                        transform: "translateX(12px)",
                        color: "#fff",
                        "& + .MuiSwitch-track": {
                          opacity: 1,
                          backgroundColor: "#007da8",
                        },
                      },
                    },
                    "& .MuiSwitch-thumb": {
                      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
                      width: "10px",
                      height: "10px",
                      borderRadius: 6,
                    },
                    "& .MuiSwitch-track": {
                      borderRadius: 16 / 2,
                      opacity: 1,
                      backgroundColor: "#969696",
                      boxSizing: "border-box",
                    },
                  }}
                  disableRipple
                />
              </div>
            </div>
            
            <div className="customerInfo-content">
              <div className="basicInfo">
                <div className="labelSet">
                  <span>
                    {this.props.intl.formatMessage({id: "user_id"})}
                  </span>
                  <div className="inputField disabled">
                    <input
                      type="text"
                      name="userName"
                      value={this.state.user.userId}
                      size="20"
                    />
                  </div>
                </div>
                <div className="labelSet">
                  <span>
                    {this.props.intl.formatMessage({id: "customer_email_address"})}
                  </span>
                  <div className={this.state.isChangeEmail ? "inputField" : "inputField disabled"}>
                    <input
                      type="email"
                      name="email"
                      size="45" 
                      maxLength="128"
                      value={this.state.user.mailAddress}
                      onInput={event => { this.onEmailValidation(event) }}
                      onChange={event => this.onEmailChange(event.target.value)} 
                    />
                  </div>
                </div>
              </div>
              <div className="otherInfo">
                 {/* jobManager */}
                <div className="jobManager">
                  <div className="check">
                    <input
                      type="checkbox"
                      disabled={this.state.jobManagerDisabled || this.state.JobManagerScheduleDisabled}
                      checked={this.state.jobManagerChecked}
                      onChange={this.handleJobManagerChanged}
                    />
                    <span>
                      {this.props.intl.formatMessage({id: "ce_edit_jobManager"})}
                    </span>
                  </div>
                  <div className="licenseInfo">
                    <div className="labelSet">
                      <span>
                        {this.props.intl.formatMessage({id: "license"})}
                      </span>
                      <div className="inputField disabled">
                        <input
                          type="text"
                          name="licenseValidity"
                          value={jobManagerLicense?.type || "-"}
                          size="20"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="labelSet">
                      <span>
                        {this.props.intl.formatMessage({id: "ce_edit_licenseExpiresOn"})}
                      </span>
                      <div className="inputField disabled">
                        <input
                          type="text"
                          name="licenseEndDate"
                          value={jobManagerLicense?.endDate || "-"}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="machineConfig">
                    <div className="jmAuthDownload">
                      <Button
                        variant="outlined"
                        id="jmAuthDownloadButton"
                        onClick={() => this.downloadJsonFile("jmuser.json")}
                        disabled={!this.state.jobManagerDisabled}
                      >
                        {this.props.intl.formatMessage({id: "ce_essential_link_file"})}
                      </Button>
                    </div>
                    <div className="switch-beta">
                      <input
                        type="checkbox"
                        disabled={!this.state.jobManagerChecked}
                        checked={this.state.jobManagerChecked ? this.state.user.isLocation : false}
                        onChange={(event) =>this.handleLocationOnOff(event.target.checked)}
                        className={this.state.jobManagerChecked ? "" :"disabled"}
                      />
                      <span>
                        {this.props.intl.formatMessage({id: "ce_location_on_off"})}
                      </span>
                    </div>
                  </div>
                </div>
                {/* ultimate */}
                <div className="ultimate">
                  <div className="check">
                    <input
                      type="checkbox"
                      disabled={this.state.ultimateDisabled || this.state.JobManagerScheduleDisabled}
                      checked={this.state.ultimateChecked}
                      onChange={this.handleUltimateChanged}
                    />
                    <span>
                      {this.props.intl.formatMessage({id: "ce_edit_utimate"})}
                    </span>
                  </div>
                  <div className="licenseInfo">
                    <div className="labelSet">
                      <span>
                        {this.props.intl.formatMessage({
                          id: "license",
                        })}
                      </span>
                      <div className="inputField disabled">
                        <input
                          type="text"
                          name="licenseValidity"
                          value={ultimateLicense?.type || "-"}
                          size="20"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="labelSet">
                      <span>
                        {this.props.intl.formatMessage({
                          id: "ce_edit_licenseExpiresOn",
                        })}
                      </span>
                      <div className="inputField disabled">
                        <input
                          type="text"
                          name="licenseEndDate"
                          value={ultimateLicense?.endDate || "-"}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="machineConfig">
                    <div className="switchAqa">
                      <input
                        type="checkbox"
                        disabled={!this.state.ultimateChecked}
                        checked={this.state.user.showAqaQuality}
                        onChange={(event) =>this.handleShowAqaQuality(event.target.checked)}
                        className={this.state.ultimateChecked ? "" :"disabled"}
                      />
                      <span>
                        {this.props.intl.formatMessage({id: "aqa_quality_information"})}
                      </span>
                    </div>
                    <div className="buttonGroup">
                      <div className="buttonContainer">
                        <Button
                          className={this.state.ultimateChecked ? "buttons" :"buttons disabled"}
                          onClick={this.state.ultimateChecked ? () => this.goSuggestion() : null}
                          disabled={!this.state.ultimateChecked}
                        >
                          {this.props.intl.formatMessage({ id: "edit_suggestion" })}
                        </Button>
                      </div>
                      {
                        process.env.REACT_APP_BUILD_ENV === 'prod' ?
                        <div className="buttonContainer">
                        <Button
                          variant="outlined"
                          className={this.state.ultimateChecked ? "buttons" :"buttons disabled"}
                          onClick={this.state.ultimateChecked ? () => this.onClickTransportLog() : null}
                          disableRipple
                        >
                          {this.props.intl.formatMessage({id: "ce_edit_transportLog"})}
                        </Button>
                      </div> : ""
                      }
                      <div className="buttonContainer">
                        <Button
                          variant="outlined"
                          className={this.state.ultimateChecked ? "buttons" :"buttons disabled"}
                          onClick={this.state.ultimateChecked ? () => this.onClickAddSerialNumber() : null}
                          startIcon={<AddIcon />}
                          disableRipple
                        >
                          {this.props.intl.formatMessage({id: "ce_edit_addSerialNumber"})}
                        </Button>
                      </div>
                    </div>
                  </div>
                  {this.MashineListLayout(this.state.user.machineList)}
                  {!this.state.serialNumberVaild && (
                    <p className="serialNumber-error-message">
                      <ErrorOutlineIcon color="error" />
                      {this.props.intl.formatMessage({
                        id: "ce_sn_validation",
                      })}
                    </p>
                  )}
                </div>
                {/* new jobManager */}
                <div className="jobManagerNew">
                  <div className="check">
                    <input
                      type="checkbox"
                      disabled={this.state.JobManagerScheduleDisabled || this.state.jobManagerDisabled || this.state.ultimateDisabled}
                      checked={this.state.jobManagerScheduleChecked}
                    />
                    <span>
                      {this.props.intl.formatMessage({id: "ce_addCustomers_ScheduleJM_title"})}
                    </span>
                  </div>
                  <div className="licenseInfo">
                    <div className="labelSet">
                      <span>
                        {this.props.intl.formatMessage({
                          id: "license",
                        })}
                      </span>
                      <div className="inputField disabled">
                        <input
                          type="text"
                          name="licenseValidity"
                          value={JobManagerScheduleLicense?.type || "-"}
                          size="20"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="labelSet">
                      <span>
                        {this.props.intl.formatMessage({
                          id: "ce_edit_licenseExpiresOn",
                        })}
                      </span>
                      <div className="inputField disabled">
                        <input
                          type="text"
                          name="licenseEndDate"
                          value={JobManagerScheduleLicense?.endDate || "-"}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="machineConfig">
                    <div className="switch-beta">
                      <input
                        type="checkbox"
                        disabled={true}
                        checked={this.state.jobManagerScheduleChecked}
                        className="disabled"
                      />
                      <span>
                        {this.props.intl.formatMessage({id: "ce_addCustomers_Schedule_switch_label"})}
                      </span>
                    </div>
                    <div className={this.state.user.isFlux ? "copyInfo" : "copyInfo copyinfo-hidden"} onClick={() => this.copywebhookInfoToClipboard()}>
                        <span>{this.props.intl.formatMessage({ id: "ce_editCustomers_flux_endpoint_url" })}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 共通情報 */}
          <div className="commonInfo">
            <div className="commonInfo-title">
              {this.props.intl.formatMessage({id: "ce_edit_commonInfo"})}
            </div>
            {this.CEListLayout(this.state.user.ceList)}
          </div>

          <div className="ceEdit-footer">
            <div className="buttons">
              <div>
                <div className="errMsg">
                  <span>{this.state.error}</span>
                </div>
              </div>
              
              <Button
                fullWidth
                id="registerButton"
                className={this.registerBtnClassName()}
                onClick={() => {
                  this.handleUpdate();
                }}
                disabled={
                  _.isEqual(this.state.user, this.state.userBeforeChange) ||
                  this.state.isProgress ||
                  !this.state.serialNumberVaild
                }
              >
                {this.props.intl.formatMessage({
                  id: "update",
                })}
              </Button>
              <Button
              sx={{
                color:"rgba(0, 0, 0, 0.87)"
              }}
                fullWidth
                id="goBackButton"
                className="button"
                onClick={() => this.jumpToListPage()}
              >
                {this.props.intl.formatMessage({id: "go_back"})}
              </Button>
            </div>
          </div>
        </div>
        <ConfirmationDialog
          show={this.state.showConfirmationDialog}
          handleClose={() => {
            this.setState({ showConfirmationDialog: false });
          }}
          register={() => {
            this.handleRegister();
          }}
          intl={this.props.intl}
          message={"ce_confirmation_message"}
          btnText={"update"}
        />
        <TransportLogDialog
          show={this.state.showTransportLogDialogFlag}
          handleClose={() => {
            this.setState({ showTransportLogDialogFlag: false });
          }}
          handleApply={(machineInfoList) => {
            this.updateTransportLog(machineInfoList);
          }}
          intl={this.props.intl}
          machineList={ this.state.transportLogMachines}
        />
      </div>
    );
  }
}

function getMachineLogStatus(logStatus) {
  if (logStatus === LOG_STATUS_VALUE.NO_LOG) {
    return "no_log";
  } else if (logStatus === LOG_STATUS_VALUE.UNUSED_LOG) {
    return "unused_log";
  } else {
    return logStatus;
  }
}

export default withSnackbar(
  withRouter(injectIntl(editCustomerDetails)),
  SNACKBAR_OPTIONS
);
